var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1 1 9.9 9.9z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1 1 9.9 9.9",
    stroke: "inherit"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 1 1 10.9z",
    fill: "inherit"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9 1 1 10.9",
    stroke: "inherit"
  })));
};
export { SvgClose as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='12' height='12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fillRule='evenodd' clipRule='evenodd' d='M1 1l9.9 9.9z' fill='inherit'/%3E %3Cpath d='M1 1l9.9 9.9' stroke='inherit' strokeWidth='1.2' strokeLinecap='round'/%3E %3Cpath fillRule='evenodd' clipRule='evenodd' d='M10.9 1L1 10.9z' fill='inherit'/%3E %3Cpath d='M10.9 1L1 10.9' stroke='inherit' strokeWidth='1.2' strokeLinecap='round'/%3E %3C/svg%3E";